import request from '@/utils/request'

const getConfig = () => {
  return request({
    url: '/api/chat/config',
    method: 'get'
  })
}

const sendMessage = data => {
  return request({
    url: `/api/chat/send-message`,
    method: 'post',
    data
  })
}

const getHistory = data => {
  return request({
    url: `/api/chat/history`,
    method: 'post',
    data
  })
}

function uploadImage(file, onUploadProgress) {
  let formData = new FormData()
  formData.append('file', file)

  return request({
    url: `/api/chat/upload-image`,
    method: 'post',
    timeout: 300000, // 5 mins
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData,
    onUploadProgress
  })
}

function uploadVideo(file, onUploadProgress) {
  let formData = new FormData()
  formData.append('file', file)

  return request({
    url: `/api/chat/upload-video`,
    method: 'post',
    timeout: 300000, // 5 mins
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData,
    onUploadProgress
  })
}

function markAllAsRead(data) {
  return request({
    url: `/api/chat/read-customer/`,
    method: 'put',
    data
  })
}

export default {
  sendMessage,
  getHistory,
  uploadImage,
  uploadVideo,
  markAllAsRead,
  getConfig
}
